// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "@fortawesome/fontawesome-free/js/all";
import "preline";
import "@preline/carousel";
import "mapkick/bundle";
import "trix";
import "@rails/actiontext";
import "./companion";
import "@37signals/lexxy";
